import { render, staticRenderFns } from "./MindfulnessClass.vue?vue&type=template&id=2081e6b2&"
import script from "./MindfulnessClass.vue?vue&type=script&lang=js&"
export * from "./MindfulnessClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports